import React from 'react';

export default ({ codCli, nome, total }) => (
  <span>
    <span className="span-title">
      <span className="font-bold">      
        {nome}
        {` (${total})`}
      </span>
    </span>
  </span>
);



// WEBPACK FOOTER //
// ./src/screens/client/profile/TitleAccordionPortfolioProfile.jsx